import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-uri-confirmation-dialog',
  standalone: false,
  templateUrl: './uri-confirmation-dialog.component.html',
  styleUrl: './uri-confirmation-dialog.component.scss'
})
export class UriConfirmationDialogComponent {

  constructor(
        public dialogRef: MatDialogRef<UriConfirmationDialogComponent>,
      ) { }
    
      closeDialog() {
        this.dialogRef.close();
      }
    
      acceptDialog() {
        this.dialogRef.close('accepted');
      }
}
